export default "__VITE_PUBLIC_ASSET__a0d25ac1__"